module.exports = __webpack_public_path__ + "img/gz.8b5d0125.png";